import { useEffect, useState } from 'react';

export function useLowStockSetting() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    fetch('/api/settings/notifications')
      .then(res => res.json())
      .then(data => setEnabled(!!data.lowStock));
  }, []);

  return enabled;
}
